import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Affirmation} from '../../../../models/applicationFeature';
import {MatDialog} from '@angular/material/dialog';
import {CompleteAffirmationDialogComponent} from '../complete-affirmation-dialog/complete-affirmation-dialog.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-affirmation-card-template',
  templateUrl: './affirmation-card-template.component.html',
  styleUrls: ['./affirmation-card-template.component.scss']
})
export class AffirmationCardTemplateComponent implements OnInit, AfterViewInit {
  @Input() affirmation: Affirmation;
  @Input() children: any;
  affirmationAnnouncementContent: string;
  @ViewChild('affirmationContent', {static: false}) content: ElementRef;
  constructor(public router: Router) {
    this.affirmationAnnouncementContent = '';
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // this.affirmationAnnouncementContent = this.affirmation.announcement_text ?
    //     this.ellipsify(JSON.parse(this.affirmation.announcement_text)) : '';
    // this.content.nativeElement.innerHTML = this.affirmationAnnouncementContent;
  }

  ellipsify(str) {
    const content = str.trim();
    if (content.length > 250) {
      return (content.substring(0, 250) + '...');
    } else {
      return content;
    }
  }

  async completeAffirmation() {
    await this.router.navigate(['home/complete-affirmation'], {queryParams: {id: this.affirmation.id}});
    // this.dialog.open(CompleteAffirmationDialogComponent, {
    //   height: '60%',
    //   width: '45%',
    //   data: {
    //     affirmation: this.affirmation,
    //     children: this.children
    //   }
    // });
  }
}
